import MenuRow from './_menu-row.js'
import ButtonBar from './_button-bar.js'

export default {
  name: 'MarketGroupSelector',
  values: {
    scrollable: false,
    _mobile_scrollable: true,
    newFeatureMarketGroupIds: undefined,
    marketsMenu: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            width: 'auto',
            padding: '8px 0 0 8px',
            _mobile_padding: '0',
            height: 'auto',
            boxSizing: 'border-box',
          },
        },
        buttonScrollPane: {
          contentContainer: {
            itemSpacing: '8px',
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '64px',
                minHeight: '40px',
                padding: '0 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '64px',
                minHeight: '40px',
                padding: '0 8px',
              },
            },
          },
        },
      },
    },
    buttonBar: {
      configSet: ButtonBar,
      configValues: {
        enableExpandCollapse: true,
        containerCollapsed: {
          style: {
            height: '40px',
          },
        },
        container: {
          style: {
            padding: '8px 0 0',
            _mobile_padding: '8px 8px 0',
          },
        },
        button: {
          selected: {
            style: {
              base: {
                padding: '0 8px',
                minHeight: '40px',
                minWidth: '64px',
                whiteSpace: 'noWrap',
              },
            },
          },
          unselected: {
            style: {
              base: {
                padding: '0 8px',
                minHeight: '40px',
                minWidth: '64px',
                whiteSpace: 'noWrap',
              },
            },
          },
        },
        expandButton: {
          style: {
            base: {
              maxHeight: '40px',
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
